import { Link } from "../../router";
import { useAppState } from "../../state/appState";
import { Empty, StatusChip, useTicker } from "../../ui/components";
import { money, timeOnly } from "../../ui/format";
import { isOverdue } from "../OrderTicket";

const SHOP_MODE_LABELS: Record<string, string> = {
  open: "Открыто",
  paused: "Приём остановлен",
  closed: "Закрыто"
};

export function DashboardPage() {
  const { snapshot } = useAppState();
  const now = useTicker(5000);

  if (!snapshot) return <Empty>Загрузка данных…</Empty>;

  const orders = snapshot.orders;
  const today = new Date().setHours(0, 0, 0, 0);
  const todayOrders = orders.filter(order => new Date(order.createdAt).getTime() >= today);
  const paidToday = todayOrders.filter(order => order.paymentStatus === "paid");
  const revenue = paidToday.reduce((sum, order) => sum + order.total - order.refundAmount, 0);
  const inWork = orders.filter(order => ["paid", "accepted", "cooking"].includes(order.status));
  const waitingCourier = orders.filter(order => order.status === "ready" && !order.courierId);
  const overdue = orders.filter(order => isOverdue(order, now));

  return (
    <>
      <div className="page-head">
        <div>
          <p className="eyebrow">Операционная сводка</p>
          <h1>Главная</h1>
        </div>
        <span className="chip">{SHOP_MODE_LABELS[snapshot.settings.shopMode] ?? snapshot.settings.shopMode}</span>
      </div>

      <div className="metrics">
        <div className="metric">
          <b className="num">{paidToday.length}</b>
          <span>Оплачено сегодня</span>
        </div>
        <div className="metric">
          <b className="num">{money(revenue)}</b>
          <span>Выручка за вычетом возвратов</span>
        </div>
        <div className="metric">
          <b className="num">{inWork.length}</b>
          <span>В работе на кухне</span>
        </div>
        <div className="metric">
          <b className="num">{waitingCourier.length}</b>
          <span>Ждут доставщика</span>
        </div>
        <div className="metric">
          <b className="num">{overdue.length}</b>
          <span>Просрочено</span>
        </div>
        <div className="metric">
          <b className="num">{snapshot.settings.baseEtaMinutes} мин</b>
          <span>Базовый прогноз</span>
        </div>
      </div>

      <section className="panel">
        <header>
          <h2>Последние заказы</h2>
          <Link className="btn btn-sm" to="/orders">
            Все заказы
          </Link>
        </header>

        {orders.length === 0 ? (
          <Empty>Заказов пока нет.</Empty>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Заказ</th>
                  <th>Лавочка</th>
                  <th>Оплачен</th>
                  <th>Статус</th>
                  <th>Сумма</th>
                </tr>
              </thead>
              <tbody>
                {orders.slice(0, 8).map(order => (
                  <tr key={order.id}>
                    <td className="num">№{order.number}</td>
                    <td className="num">{order.benchId}</td>
                    <td className="num">{timeOnly(order.paidAt)}</td>
                    <td>
                      <StatusChip status={order.status} />
                    </td>
                    <td className="num">{money(order.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </>
  );
}
